
import axios from "axios";

export default class ContactService {

  getAllContact = async () => {
    try {
      const response = axios.get(`${process.env.REACT_APP_API_URL}/contact`);
      return response;
    } catch (error) {
      throw new Error("Erreur  : " + error.message);
    }
  };
    getAllContactForm = async () => {
    try {
      const response = axios.get(`${process.env.REACT_APP_API_URL}/contact-forms`);
      return response;
    } catch (error) {
      throw new Error("Erreur  : " + error.message);
    }
  };
}
